import type { NotificationTemplate } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export async function resetTemplate(
  workspaceSlug: string,
  templateType: string,
): Promise<NotificationTemplate> {
  const response = await AuthAxios.post<NotificationTemplate>(
    `/api/v1.0/e/${workspaceSlug}/notification-templates/reset/${templateType}`,
  )
  return response.data
}
